import { createAction, props } from '@ngrx/store';
import { DataDictionaryItem } from '../../components/data-dictionary/data-dictionary.component';
import { DataDictionaryState } from './data-dictionary.reducer';

// Data dictionary actions

export const SetDataDictionary = createAction(
  '[DataDictionary] Set data dictionary',
  props<{ items: Array<DataDictionaryItem>; title: string; tabTitle?: string; tabIcon?: string }>()
);

export const OpenDataDictionary = createAction(
  '[DataDictionary] Open data dictionary',
  props<{ items: Array<DataDictionaryItem>; title: string; tabTitle?: string; tabIcon?: string }>()
);

export const OpenDataDictionarySuccess = createAction('[DataDictionary] Open data dictionary success');

// Handle state from Tab actions

export const RestoreState = createAction('[DataDictionary] Restore state from tab', props<{ state: DataDictionaryState }>());

export const ClearState = createAction('[DataDictionary] Clear state');
